import { useEffect, useState } from "react";

import { fetchPopularSubjects } from "./metadata";

type UsePopularSubjectsOptions = {
  limit?: number;
};

export function usePopularSubjects(options?: UsePopularSubjectsOptions) {
  const [data, setData] = useState<string[] | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const limit = options?.limit ?? 12;

  useEffect(() => {
    let isMounted = true;

    fetchPopularSubjects(limit)
      .then((subjects) => {
        if (!isMounted) return;
        setData(subjects);
        setError(null);
      })
      .catch(() => {
        if (!isMounted) return;
        setError("Impossible de charger les matières populaires.");
      })
      .finally(() => {
        if (!isMounted) return;
        setLoading(false);
      });

    return () => {
      isMounted = false;
    };
  }, [limit]);

  return { data, loading, error };
}
